export type GridTableHeaderConfig = {
    label: string;
    align?: "left" | "center" | "right";
};

export type GridTableProps<T> = {
    data: T[];
    headings: GridTableHeaderConfig[];
    renderRow: (dataRow: T, index: number) => React.ReactNode;
    gridTemplateColumns: string;
};

const GridTable = <T extends { id: number }>({
    data,
    headings,
    renderRow,
    gridTemplateColumns,
}: GridTableProps<T>) => {
    return (
        <div className="grow rounded-xl border border-surface-light-5 overflow-hidden">
            <div
                className="border-b border-b-surface-light-5 bg-deep-ocean-20 text-white child:py-2 sm:child:py-4 child:px-4 text-sm"
                style={{
                    display: "grid",
                    gridTemplateColumns,
                }}
            >
                {headings.map((heading) => (
                    <div
                        key={heading.label}
                        className={
                            heading.align === "center"
                                ? "text-center"
                                : heading.align === "right"
                                ? "text-right"
                                : "text-left"
                        }
                    >
                        {heading.label}
                    </div>
                ))}
            </div>
            {data.map((rowData, index) => (
                <div
                    key={rowData.id}
                    className="grid grid-cols-3 items-center border-b border-b-surface-light-5 text-xs child:px-4"
                    style={{
                        display: "grid",
                        gridTemplateColumns,
                    }}
                >
                    {renderRow(rowData, index)}
                </div>
            ))}
        </div>
    );
};

export default GridTable;
